import * as L from 'leaflet'
import 'leaflet.markercluster'
import 'leaflet-polylinedecorator'

import BaseSchemaDrawer from '../../../utils/map/BaseSchemaDrawer.js'
import {OBJECT} from '../../../utils/map/types.js'
import {TREADS_POLY_STYLE} from "../../../config/map";


class ThreadsDrawer extends BaseSchemaDrawer {
  _relations = [];
  _arrows = {};
  _tkoObjectsFromRemovedRelations = [];

  bringToMarker (obj, zoomTo) {
    this.updateZoom();
    let zoom = zoomTo || obj.showAfterZoom || this._zoom;
    if (zoom >= this._zoom) {
      zoom = zoom + 1
    }
    if (zoom < 8) {
      zoom = 9
    }
    let marker = this.getOrCreateMarker(obj);
    this._map.setView(marker.getLatLng(), zoom);
    this.drawIfNotExist(marker);
    this.createPopup(marker, {forceReDraw: true});
    return marker
  }

  initObservers () {
    this.$emitter = this.vm.$emitter;
    this.showMarkerSubs = this.$emitter.listen('geo.threadsDrawer.showMarker', data => this.showMarker(data))
  }

  // TODO: if tko object hide after delete relation, search here
  showMarker (data) {
    if (data.obj) {
      for (let i = 0; i < this._tkoObjects.length; i++) {
        let id = data.obj.tko_object_id || data.obj.id;
        if (this._tkoObjects[i].id === id) {
          this.drawIfNotExist(this.getOrCreateMarker(this._tkoObjects[i]));
          break
        }
      }
    }
  }

  redrawAll () {
    this.removeAllPaths();
    this.drawRelations();
    this.drawCities();
    this.drawTkoObjects()
  }

  removeAllPaths () {
    for (let key in this._polylines) {
      if (this._polylines[key]) {
        this._polylines[key].remove();
        this._polylines[key] = null
      }
    }
    for (let key in this._arrows) {
      if (this._arrows[key]) {
        this._arrows[key].remove();
        this._arrows[key] = null
      }
    }
  }

  refreshMap (relations, settlements, tkoObjects, garbageSources = {}) {
    console.log('refreshMap');
    this.removeAllObjects();
    this.setRelations(relations);
    this.setCities(settlements);
    this.setTkoObjects(tkoObjects);

    if(garbageSources){
      this.setGarbageSources(garbageSources)
    }
    this.$emitter.emit('geo.threadsDrawer.refreshed', {})
  }

  setRelations (relations) {
    this.removeAllPaths();
    this._relations = relations || [];
    this.drawRelations()
  }

  drawRelations () {
    this.updateZoom();
    const showDeleted = this.vm.$route.query.showDeleted;
    this._tkoObjectsFromRemovedRelations = [];
    for (const v of this._relations) {
      const tkoDel = (v.start && v.start.thread_del) || (v.end && v.end.thread_del);
      const relationDel = (v.start && v.start.is_del) || (v.end && v.end.is_del);
      const hasRemoved = tkoDel || relationDel;

      if (hasRemoved) {
        //console.warn('tkoDel || relationDel', tkoDel, relationDel)
        if (showDeleted) {
          this.getOrCreateRelation(v)
        } else {
          if (relationDel) {
            if (!v.start.thread_del && v.start.type === OBJECT.TKO) {
              this.addTkoObjectFromRemovedRelation(v.start)
            }
            if (!v.end.thread_del && v.end.type === OBJECT.TKO) {
              this.addTkoObjectFromRemovedRelation(v.end)
            }
          }
        }
      } else {
        this.getOrCreateRelation(v)
      }
    }
  }

  addTkoObjectFromRemovedRelation (v) {
    // console.log('addTkoObjectFromRemovedRelation', v)
    this._tkoObjectsFromRemovedRelations.push(v)
  }

  drawTkoObjects () {
    this.updateZoom();
    this.createClusterIfNotExist();

    this._tkoObjects.forEach(v => this.drawTkoObject(v));
    this._tkoObjectsFromRemovedRelations.forEach(v => this.drawTkoObject(v))
  }

  drawTkoObject (v) {
    const showDeleted = this.vm.$route.query.showDeleted;
    if (!showDeleted && v.thread_del) {
      return
    }

    // console.log(v)
    const openedPopupInfo = this.vm.$route.query.openedPopupInfo;
    const markerId = this.getMarketId(v);
    if (this._tkoCluster.options.markersInLayer.indexOf(markerId) === -1) {
      const marker = this.getOrCreateMarker(v);
      marker.on('click', () => {
        this.createPopup(marker)
      });
      this._tkoCluster.addLayer(marker);
      this._tkoCluster.options.markersInLayer.push(markerId);

      if (openedPopupInfo && marker.options.openedPopupInfo === openedPopupInfo) {
        this.createPopup(marker)
      }
    }
  }

  getOrCreateRelation ({start, end, relationType}) {
    let model = {
      type: OBJECT.REL,
      relationType,
      start,
      end
    };
    let lineId = this.getMarketId(model);
    if (this._removedPolylines[lineId]) {
      return
    }

    if (this.isCanShowOnThatZoom(start) && this.isCanShowOnThatZoom(end)) {
      let startMarker = this.getOrCreateMarker(start);
      let endMarker = this.getOrCreateMarker(end);

      this.drawIfNotExist(startMarker);
      this.drawIfNotExist(endMarker);

      if (!this._polylines[lineId]) {
        let polyStyle = {};
        if (start.is_del || end.is_del) {
          polyStyle = {...TREADS_POLY_STYLE.removed}
        } else if (end.is_plan || start.is_plan) {
          polyStyle = {...TREADS_POLY_STYLE.planned}
        } else {
          polyStyle = {...TREADS_POLY_STYLE.fact}
        }
        polyStyle.weight = 0 + this._zoom * 0.2;

        if (start.color) {
          polyStyle.color = start.color
        }
        if (end.color) {
          polyStyle.color = end.color
        }
        if (start.color && end.color) {
          console.warn(`Конфликт цветов`)
        }


        let polyLineOptions = {
          ...polyStyle,
          remove: (layer) => {
            this.removePolyline(layer)
          },
          lineId,
          model
        };

        this._polylines[lineId] = L.polyline([startMarker.getLatLng(), endMarker.getLatLng()], polyLineOptions);
        this._polylines[lineId]
          .bindTooltip(end.relationTooltip, {sticky: true})
          .addTo(this._map);
        startMarker.bringToFront && startMarker.bringToFront();
        endMarker.bringToFront && endMarker.bringToFront();

        // значение offset подобрано таким  образом
        // чтобы при масштабе 4 не было видно стрелки
        // адекватное решение это рисовать маркеры с нужной стрелкой
        this._arrows[lineId] = L.polylineDecorator(this._polylines[lineId], {
          patterns: [
            {
              offset: 18,
              repeat: 100,
              symbol: L.Symbol.arrowHead({
                pixelSize: polyStyle.arrowSize,
                polygon: false,
                pathOptions: {
                  color: polyStyle.color,
                  weight: polyStyle.weight,
                  stroke: true
                }
              })
            }
          ]
        }).addTo(this._map);

        let self = this;
        this._polylines[lineId]
          .on('click', function (e) {
            try {
              this.options.lastEventPos = e.latlng;
              this.options.lastEventPoint = e.layerPoint;
              this.options.lastEvent = e;
              this.options.lastEventNoPan = true
            } catch (e) {
              console.error('lost context: ' + e.toString())
            }
            // write popup coords in lastEventPos
            let {lat = 0, lng = 0} = e.latlng || {};
            self.createPopup(self._polylines[lineId], {forceReDraw: true, lastEventPos: `${lat},${lng}`})
          });

        if (this.vm.$route.query.openedPopupInfo && lineId === this.vm.$route.query.openedPopupInfo) {
          if (this.vm.$route.query.lastEventPos) {
            let [lat, lng] = this.vm.$route.query.lastEventPos.split(',');
            this.createPopup(this._polylines[lineId], {lastEventPos: `${lat},${lng}`})
              .setLatLng(L.latLng(lat, lng))
          } else {
            this.createPopup(this._polylines[lineId])
          }
        }
      }
      // show only tko, for prevent empty lines to unknown
    } else if (this.isCanShowOnThatZoom(end)) {
      let endMarker = this.getOrCreateMarker(end);
      this.drawIfNotExist(endMarker)
    } else {
      if (this._polylines[lineId]) {
        this._polylines[lineId].remove();
        this._polylines[lineId] = null
      }
      if (this._arrows[lineId]) {
        this._arrows[lineId].remove();
        this._arrows[lineId] = null
      }
      this.removeMarkerIfExist(start);
      this.removeMarkerIfExist(end)
    }
  }
}

export default ThreadsDrawer
